import { ERROR_MESSAGES } from 'www/vue_components/common/Club/constants'

function alertUserErrors(errors) {
  let errorMessage = ''

  if (Array.isArray(errors)) {
    const [error] = errors

    if (error.non_field_errors) {
      errorMessage = ERROR_MESSAGES.non_field_errors[error.non_field_errors.code]
    }
  }

  if (errors.email) {
    errorMessage = ERROR_MESSAGES.email[errors.email.code]
  }

  if (errors.detail) {
    // eslint-disable-next-line no-alert
    alert(ERROR_MESSAGES.appointmentReject)

    return
  }

  if (errorMessage) {
    // eslint-disable-next-line no-alert
    alert(errorMessage)
  }
}

export default alertUserErrors
